import { Card, Col, Row } from 'antd'
import { useEffect, useMemo, useState } from 'react'

import JourneySetSumary from './Summary'

import { POLL_INTERVAL } from '~/client'
import HeadTitle from '~/components/HeadTitle'
import { LoadingComponent } from '~/components/Query/utils'
import { PermissionOnly } from '~/components/Session'
import UserSummary from '~/components/User/Summary'
import { useJourneySetQuery } from '~/gql/generated/graphql'
import useHash from '~/hooks/useHash'
import JourneySetMap from '../Map'
import JourneyTabs from './JourneyTabs'

export type IDProps = {
  id: string
  schemeId?: string
}

export const JourneySet = ({ id, schemeId }: IDProps) => {
  const [pollInterval, setPollInterval] = useState<number>(POLL_INTERVAL)
  const { data, loading } = useJourneySetQuery({
    variables: { id, schemeId },
    pollInterval,
  })
  const [hash, setHash] = useHash()

  const isComplete = data?.journey_set?.is_complete ?? false

  if (isComplete && pollInterval !== 0) {
    setPollInterval(0)
  }

  const activeJourneyId = useMemo(
    () =>
      data?.journey_set.journeys.map(({ id }) => id).includes(hash ?? '')
        ? hash
        : undefined,
    [data?.journey_set.journeys, hash],
  )

  useEffect(() => {
    if (data?.journey_set.journey_count === 1) {
      setHash(data.journey_set.journeys[0].id)
    }
  }, [data?.journey_set.journey_count])

  if (loading || !data) return <LoadingComponent />

  if (!data?.journey_set) {
    return null
  }

  const journeySet = data.journey_set
  const { id: journeySetId, user, journeys } = journeySet

  return (
    <>
      <HeadTitle pageTitle={`Group Ride ${journeySetId}`} />
      <Row gutter={[16, 16]} className="fill-height">
        <Col lg={10} xs={24} className="flex-col">
          <JourneySetSumary id={id} />
          <JourneyTabs
            journeys={journeys}
            activeJourneyId={activeJourneyId}
            setActiveJourneyId={setHash}
          />
        </Col>
        <Col lg={14} xs={24} style={{ minHeight: 500 }}>
          <Card
            id="journey-map-card"
            bodyStyle={{ padding: 0 }}
            style={{ containerType: 'size' }}
          >
            <JourneySetMap
              schemeId={journeySet.scheme.id}
              journey_set_id={journeySet.id}
              activeJourneyId={activeJourneyId}
              pollInterval={pollInterval}
            />
          </Card>
        </Col>
        <PermissionOnly permission="user.view">
          {user?.id && (
            <Col lg={24}>
              <Card id="journey-user-card">
                <UserSummary id={user.id} fillRow />
              </Card>
            </Col>
          )}
        </PermissionOnly>
      </Row>
    </>
  )
}

export default JourneySet
